import ABCyaPhaser from '@abcya/abcya_phaser'
import FontKeys from '../FontKeys';
import gameData from '../gameData';
import Key from './Key';

export default class Keyboard extends Phaser.GameObjects.Container
{
    constructor(scene, x, y)
    {
        super(scene, x, y);
        scene.add.existing(this);

        this.scene = scene;

        this.isActive = false;
        this.keySizeHeight = 75;
        this.keySizeWidth = 55;
        this.keySpacing = 8;

        this.pos = {
            startX:x,
            startY:y,
            endY:this.scene.mid.y*2 - 215
        }

        this.soundInd = 0;

        this.initKeys();
        if(!gameData.DESKTOP) this.tweenInKeyboard();
    }

    initKeys()
    {    
        //add touch handle to keys for mobile
        if(!gameData.DESKTOP){
            // console.log("creating keyboard");
            const bgShape = ABCyaPhaser.Graphics.addRect(0, 140, this.scene.mid.x*2, 400, "0x18A079", this);

            this.secondRow = this.createRow(["q","w","e","r","t","y","u","i","o","p"]);
            this.midRow = this.createRow(["a","s","d","f","g","h","j","k","l"]);
            this.bottomRow = this.createRow(["z","x","c","v","b","n","m"]);
            this.keys = [this.secondRow,this.midRow,this.bottomRow];
            this.positionKeys();
        }
        else 
        {
            this.isActive = true;
            this.scene.input.keyboard.on('keyup', (event)=>{
                this.handleKeyPress(event.key);
            });
        }
    }

    positionKeys() {
        for(let i = 0; i< this.keys.length; i++){
            const row = this.keys[i];
            const rowWidth = (row.length * (this.keySizeWidth + this.keySpacing)) - this.keySpacing;
            //messy add to width for shift,delete,etc
            const rowStart = -(rowWidth/2);

            //also messy add to start to make uneven?
            const rowY = (i * (this.keySizeHeight + this.keySpacing)) - 40;
            for(let j = 0; j< row.length; j++){

                const key = row[j];
                key.setKeyColors("0xD8D4BC","0xF2EECE");
                key.endX = (j == 0) ? rowStart : row[j - 1].endX + row[j - 1].keyWidth + this.keySpacing;
                key.endY = rowY;
                key.x = key.endX;
                key.y = key.endY;
            }
        }
    };

    handleKeyPress(key)
    {
        if(this.isActive == true)
        {
            const letter = key?.toUpperCase();
            if(!letter) return;

            let scorePoints = false;

            for(let gw = 0; gw < gameData.ROCKET_ARR.length; gw++) {
                // console.log(letter, gameData.ROCKET_ARR[gw].innerText);
                if(letter == gameData.ROCKET_ARR[gw].innerText){
                    if(gameData.ROCKET_ARR[gw].y <= 800){
                        this.scene.explode(gameData.ROCKET_ARR[gw]);
                        gameData.ROCKET_ARR[gw].destroyRocket(true);
    
                        scorePoints = true;
                    }
                }
            }

            if(scorePoints) {
                this.scene.navBar.setScore("+");
            }
            else {
                this.scene.navBar.setScore("-");
                ABCyaPhaser.Audio.playOneShot("Incorrect_Answer", this.scene);
            }
        }
    };

    tweenInKeyboard()
    {
        ABCyaPhaser.Tweens.addTween(this, 1000, {y:this.pos.endY}, Phaser.Math.Easing.Quadratic.Out, ()=>{ 
            this.isActive = true;

            if(!gameData.DESKTOP){
                this.scene.input.on('gameobjectup', (pointer, gameObject)=>{
                    this.handleKeyPress(gameObject.parentContainer.keyStr);
                });
            }
        });
    };

    createRow(keys)
    {
        let row = [];
        while(row.length < keys.length){
            const key = new Key(this.scene, this, keys[row.length],this.keySizeWidth,this.keySizeHeight);
            row.push(key);
        }

        return row;
    };
}